/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {
//   // Add custom code below this line


  




//   // ^^ Keep your scripts inside this IIFE function call to 
//   // avoid leaking your variables into the global scope.
// })();



 $(document).ready(function() {

   $(".poup_close").on("click", function(){
     $('.popup_body').hide();
   });

   $(".newsletter_error_close").on("click", function(){
     $('.newsletter_error_wrapper').hide();
     $('.newsletter__message--error').hide();
     $('.ctm-error-popup').hide();
   });

    if (window.location.href.indexOf("customer_posted=true") > -1) {
      $('.newsletter_content').addClass('has-success');
    }

    if (window.location.href.indexOf("form_type=customer") > -1) {
       $('.newsletter_content').addClass("has-error");
    }
  
    $(".btn-slider").slick({
    dots: false,
    infinite: true,
    loop: false,
    autoplay: false,    
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed:5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<svg class="slick-button-icon slick-previous" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" fill="#000"></path></svg>',
    nextArrow:'<svg class="slick-button-icon slick-next" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)" fill="#000"></path></svg>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
        }
      }
    ] 
    }); 
      setTimeout (function() {
        var slidindex = $('.my_active:not(.slick-cloned)').attr('data-slick-index');
        $('.btn-slider').slick('slickGoTo', slidindex);
      },1200);


/* footer_collapsible js start */
  $(document).on('click','.footer-collapsible-trigger',function(){
    var acc_id = $(this).attr('data-id');
    //alert(acc_title); 
    //$('.footer-collapsible-content').removeClass("active");
    //$('#'+acc_id).toggleClass("active");
    $(this).find('.footer_icon').addClass('open');
    if($('#'+acc_id).hasClass("active")){
     $('#'+acc_id).removeClass("active");
    $(this).find('.footer_icon').removeClass('open');
    } else {
      $('.footer-collapsible-content').removeClass("active");
      $('#'+acc_id).addClass("active"); 
    }
  });
  
  /* footer_collapsible js end */

});

// $(window).on("load", function(){
// var slidindex = $('ul.page_block_row li.slick-slide.my_active').attr('data-slick-index');
// var slideno = $('.page-tab ul.page_block_row li a').attr('data-slick-index' , slidindex);
//    $('.btn-slider').slick('slickGoTo', slideno - 1);
// });


  $(window).on("load", function() {
    setTimeout (function() {
      var slidindex = $('.my_active:not(.slick-cloned)').attr('data-slick-index');
      $('.btn-slider').slick('slickGoTo', slidindex);
    },1000);
     return false;
  });


   
  